import { DashboardModule } from '@domain-group/suit-theme'

import { sanitizeFilters } from '@functions/entity'

import useCampaignQuotes from '@hooks/useCampaignQuotes'
import useCurrentUser from '@hooks/useCurrentUser'

import type { CampaignQuoteModel, CampaignQuoteRequestOptions } from '@models/types'
import useSelector from '@hooks/useSelector'
import { getCampaignPermissions, getCampaignType } from '@functions/campaign'
import Quote from './Quote'
import BlankState from './QuotesBlankState'

type Filters = {
  authorization_sent?: string,
  authorized?: string,
  campaign_id?: number,
  limit?: number,
  priority_quotes_by_user_id?: number,
  status_key?: string,
  string?: string,
}

interface CampaignQuotesProps {
  displayMode: string | undefined,
  queryParams?: Filters,
  isCampaignManager: boolean,
  requestOptions?: CampaignQuoteRequestOptions,
}

const CampaignQuotesContainer = (props: CampaignQuotesProps) => {
  const {
    displayMode, queryParams, isCampaignManager, requestOptions,
  } = props

  const { campaign_id: campaignId, limit } = queryParams || {}

  const currentUserPayload = useCurrentUser()
  const { currentUser, isAgent } = currentUserPayload
  const campaigns = useSelector(reduxState => reduxState.entities.campaigns)
  const campaign = campaigns && campaignId ? campaigns[campaignId] : {}

  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })
  const canManageQuotes = campaignPermissions.quotes.manage !== false

  const campaignQuotesPayload = useCampaignQuotes({
    filters: {
      // @ts-expect-error TS2345
      ...sanitizeFilters(queryParams),
    },
    performHttpRequests: !isCampaignManager || !!campaignId,
    requestOptions: {
      include_campaign_quote_priority_campaign_user_ids: !isAgent,
      ...requestOptions,
    },
    sortBy: 'id desc',
  })

  const { filteredCampaignQuotes, hasFilteredCampaignQuotes, loading } = campaignQuotesPayload

  const campaignQuotesArray = filteredCampaignQuotes.slice(0, limit || 50)

  return (
    <DashboardModule.ScrollableSection>
      {/*
       // @ts-expect-error TS2345 */}
      {!loading && campaignQuotesArray.map((campaignQuote: CampaignQuoteModel) => (
        <Quote
          campaignQuote={campaignQuote}
          canManageQuotes={canManageQuotes}
          // @ts-expect-error TS2322
          currentUser={currentUser}
          // @ts-expect-error TS2322
          displayMode={displayMode}
          isCampaignManager={isCampaignManager}
          key={campaignQuote.id}
        />
      ))}

      {!loading && !hasFilteredCampaignQuotes && (<BlankState />)}
    </DashboardModule.ScrollableSection>
  )
}

export default CampaignQuotesContainer
